import React from 'react';

// Denser than before (gap-4/mb-8 -> gap-3/mb-5) and labels are a small
// semibold caption above the control rather than body-sized text beside it.
const formClassName = [
  'relative',
  '[&_.field-group]:flex [&_.field-group]:gap-3 [&_.field-group]:mb-5',
  'mobile:[&_.field-group]:flex-col mobile:[&_.field-group]:mb-0 mobile:[&_.field-group_.field]:mb-4',
  '[&_.field-group_.field:not(.checkbox)]:flex [&_.field-group_.field:not(.checkbox)]:flex-col [&_.field-group_.field:not(.checkbox)]:w-full',
  '[&_.field-group_.field:not(.checkbox):last-child]:mr-0',
  '[&_.field-group_.field:not(.checkbox)_label]:mb-1.5 [&_.field-group_.field:not(.checkbox)_label]:block [&_.field-group_.field:not(.checkbox)_label]:text-[12px] [&_.field-group_.field:not(.checkbox)_label]:font-semibold [&_.field-group_.field:not(.checkbox)_label]:text-fg-2',
  '[&_.field-group_.field:not(.checkbox)_label_.icon]:relative [&_.field-group_.field:not(.checkbox)_label_.icon]:left-1 [&_.field-group_.field:not(.checkbox)_label_.icon]:cursor-pointer [&_.field-group_.field:not(.checkbox)_label_.icon]:text-fg-3',
  '[&_.field-group_.field:not(.checkbox)_.input_input]:w-full',
  '[&_.field-group_.field:not(.checkbox)_.error]:mt-1 [&_.field-group_.field:not(.checkbox)_.error]:text-[12px] [&_.field-group_.field:not(.checkbox)_.error]:text-sell',
].join(' ');

interface FormProps {
  id?: string;
  onSubmit?(e: React.FormEvent<HTMLFormElement>): void;
  children: React.ReactNode;
  className?: string;
  submitInput?: boolean;
}

export const Form = (props: FormProps) => {
  return (
    <form id={props.id} onSubmit={(e: any) => { e.preventDefault(); e.stopPropagation(); props.onSubmit?.(e); return false; }} className={`${formClassName}${props.className ? ` ${props.className}` : ''}`}>
      {props.children}
      {props.submitInput !== false && <input type="submit" className="hidden-submit hidden" /> || null}
    </form>
  );
};
